import React, { useState, useContext } from 'react';
import {
  FormWithRedirect,
  Button,
  RadioButtonGroupInput,
  SaveButton,
} from 'react-admin';
import Grid from '@material-ui/core/Grid';
import AddIcon from '@material-ui/icons/Add';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { QuickAppointmentContext } from '../../Context';
import useStyles from '../styles';

const AddressListSelection = ({
  addressList,
  setAddress,
  setIsAddingAddress,
  handleSubmit,
}) => {
  const classes = useStyles();
  const { addressData, setAddressData, handleNext, existingData } = useContext(
    QuickAppointmentContext,
  );

  const [addressCount, setAddressCount] = useState(3);

  const setSelectedAddress = (data) => {
    const { addresses } = existingData;
    const foundAddress = addresses.find((item) => item.id === data);
    setAddressData({
      customer_address_id: data,
      address_line_1: foundAddress.one_line_human_readable_address,
      city: foundAddress.city,
      country: foundAddress.country,
    });
    handleNext();
  };

  const handleAddNew = () => {
    setAddress(null);
    setIsAddingAddress(true);
  };

  const addNewButton = (
    <Grid item xs={12}>
      <Button onClick={handleAddNew} label="Add new">
        <AddIcon />
      </Button>
    </Grid>
  );

  if (!addressList.length) {
    return addNewButton;
  }

  return (
    <>
      <FormWithRedirect
        resource="customer"
        record={addressData}
        render={() => (
          <>
            <Grid container direction="column">
              <Grid item xs className={classes.hideHelperText}>
                <RadioButtonGroupInput
                  row={false}
                  source="customer_address_id"
                  choices={addressList.slice(0, addressCount)}
                  onChange={setSelectedAddress}
                />
              </Grid>
              <Grid item xs>
                {addressCount < addressList.length && (
                  <Button
                    label="Show more"
                    onClick={() =>
                      setAddressCount((prevState) => prevState + 5)
                    }
                  >
                    <ExpandMoreIcon />
                  </Button>
                )}
              </Grid>
            </Grid>
            {addNewButton}
            {!!addressData && (
              <Grid container justify="center">
                <Grid item>
                  <SaveButton
                    label="Continue"
                    handleSubmitWithRedirect={handleSubmit}
                    className={classes.buttonWithoutIcon}
                  />
                </Grid>
              </Grid>
            )}
          </>
        )}
      />
    </>
  );
};

export default AddressListSelection;
